import { useApi } from '@/shared/api/http';
import type { RequestParams } from '@/shared/model/types/http';

export const useLocationService = () => {
  const api = useApi();

  const getAllCities = async (params: RequestParams) => {
    return await api.get('city/', {
      params,
    });
  };

  const getAllRegions = async (params: RequestParams) => {
    return await api.get('region/', {
      params,
    });
  };

  const getAllDistricts = async (params: RequestParams) => {
    return await api.get('lawyer/search-district-metro/', {
      params,
    });
  };

  return {
    getAllCities,
    getAllRegions,
    getAllDistricts,
  };
};
